import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import history from '../history';
import { AUTH_TOKEN } from 'redux/constants/Auth';
import { notification, Modal } from 'antd';

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

// Config
const ENTRY_ROUTE = '/auth/login';
const TOKEN_PAYLOAD_KEY = 'authorization';
const PUBLIC_REQUEST_KEY = 'public-request';
const BEARER = 'Bearer';

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN);

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = `${BEARER} ${jwtToken}`;
    }

    if (!jwtToken && !config.headers[PUBLIC_REQUEST_KEY]) {
      window.location.href = `${ENTRY_ROUTE}`;
      //history.push(ENTRY_ROUTE);
      //window.location.reload();
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: error.toString(),
    });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    let notificationParam = {
      message: '',
    };
    if (!error.response) {
      notification.error({
        message: error.toString(),
      });
    } else {
      // Remove token and redirect
      if (
        error.response.status === 400 ||
        error.response.status === 401 ||
        error.response.status === 403
      ) {
        Modal.error({
          title: 'Authentication Failed',
          content: 'Session expired or logged in elsewhere. Please sign in again.',
          onOk: () => {
            //localStorage.removeItem(AUTH_TOKEN);
            localStorage.clear();
            //history.push(ENTRY_ROUTE);
            //window.location.reload();
            window.location.href = `${ENTRY_ROUTE}`;
          },
        });
        return Promise.reject(error);
      }

      if (error.response.status === 404) {
        notificationParam.message = 'Not Found';
      }

      if (error.response.status === 500) {
        notificationParam.message = 'Internal Server Error';
      }

      if (error.response.status === 508) {
        notificationParam.message = 'Time Out';
      }

      notification.error(notificationParam);
    }

    return Promise.reject(error);
  }
);

export default service;
